import { __makeTemplateObject, __rest, __assign } from 'tslib';
import React__default from 'react';
import styled, { useTheme } from 'styled-components';
import { Box } from '../box/Box.js';

var distributions = ["start", "middle", "end", "evenly", "fill"];
var getFlexDirection = function (_a) {
  var horizontal = _a.horizontal,
    reverse = _a.reverse;
  var axis = horizontal ? "row" : "column";
  var flexDirection = reverse ? "".concat(axis, "-reverse") : axis;
  return flexDirection;
};
var getJustifyContent = function (_a) {
  var distribute = _a.distribute;
  return {
    start: "flex-start",
    middle: "center",
    end: "flex-end",
    evenly: "space-between",
    fill: "flex-start"
  }[distribute];
};
var getSpacerSpace = function (_a) {
  var horizontal = _a.horizontal,
    space = _a.space,
    _b = _a.isFirstElement,
    isFirstElement = _b === void 0 ? false : _b;
  if (isFirstElement) return;
  var theme = useTheme();
  var spaceSize = Array.isArray(space) ? space.map(function (s) {
    return theme.spaces[s];
  }) : theme.spaces[space];
  return {
    mt: horizontal ? 0 : spaceSize,
    ml: horizontal ? spaceSize : 0
  };
};
var StackItem = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Stack__StackItem",
  componentId: "sc-od1og0-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex: ", ";\n  flex-direction: ", ";\n"], ["\n  flex: ", ";\n  flex-direction: ", ";\n"])), function (_a) {
  var fillParent = _a.fillParent;
  return fillParent ? "1 1 0%" : null;
}, function (_a) {
  var horizontal = _a.horizontal;
  return horizontal ? "row" : "column";
});
var Stack = function (_a) {
  var _b = _a.space,
    space = _b === void 0 ? 0 : _b,
    _c = _a.distribute,
    distribute = _c === void 0 ? "start" : _c,
    horizontal = _a.horizontal,
    reverse = _a.reverse,
    children = _a.children,
    rest = __rest(_a, ["space", "distribute", "horizontal", "reverse", "children"]);
  var stackedItems = React__default.Children.toArray(children).filter(function (child) {
    return !!child;
  }).map(function (child, index) {
    return React__default.createElement(StackItem, __assign({
      key: index,
      display: "flex",
      horizontal: horizontal,
      fillParent: distribute === "fill"
    }, getSpacerSpace({
      isFirstElement: index === 0,
      horizontal: horizontal,
      space: space
    })), child);
  });
  return React__default.createElement(Box, __assign({}, rest, {
    display: "flex",
    flexDirection: getFlexDirection({
      horizontal: horizontal,
      reverse: reverse
    }),
    justifyContent: getJustifyContent({
      distribute: distribute
    })
  }), stackedItems);
};
var templateObject_1;

export { Stack, distributions };
//# sourceMappingURL=Stack.js.map
